import type { Theme } from '@mui/material';

export const styles = {
  advancedSearch: (theme: Theme) => ({
    color: theme.colors.neutral[500],
    width: '100%',
    maxWidth: '50rem',
  }),

  button: {
    fontSize: 13,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};
